import { useState, useEffect } from "react"

import * as api from "../../../api"

//------------------------------------------------------------------------------

export default function useRestList(resourceUrl, token, defaultFilters) {
  const [list, setList] = useState([])
  const [count, setCount] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)

  // -------------------------------------

  // side effect: monitor page changing
  // also executed on hook mounting
  useEffect(() => {
    fetchList({
      filters: {
        ...(defaultFilters || {}),
      },
      pageNumber: currentPage,
    })

    // eslint-disable-next-line
  }, [currentPage])

  // -------------------------------------

  function fetchList(options) {
    const newOptions = {
      filters: {
        ...(defaultFilters || {}),
      },
      ...(options || {}),
    }

    api.getResourceList(resourceUrl, token, newOptions).then((res) => {
      setIsLoading(false)
      setCount(res && res.data && res.data.count)
      const newList = (res && res.data && res.data.rows) || []

      setList(newList)
    })
  }

  function loadNextPage() {
    if (!isLoading && list && count && list.length < count) {
      setIsLoading(true)
      setCurrentPage(currentPage + 1)
    }
  }

  return [list, fetchList, isLoading, count, loadNextPage, currentPage]
}
